import { css } from 'styled-components';
import * as TitilliumWebBlack from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-Black.ttf';
import * as TitilliumWebBold from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-Bold.ttf';
import * as TitilliumWebBoldItalic from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-BoldItalic.ttf';
import * as TitilliumWebSemiBold from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-SemiBold.ttf';
import * as TitilliumWebSemiBoldItalic from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-SemiBoldItalic.ttf';
import * as TitilliumWebRegular from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-Regular.ttf';
import * as TitilliumWebItalic from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-Italic.ttf';
import * as TitilliumWebLight from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-Light.ttf';
import * as TitilliumWebLightItalic from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-LightItalic.ttf';
import * as TitilliumWebExtraLight from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-ExtraLight.ttf';
import * as TitilliumWebExtraLightItalic from '@accesa/fonts/webfonts/TitilliumWeb/TitilliumWeb-ExtraLightItalic.ttf';

const TitilliumFont = 'Titillium Web';

export const TitilliumWebFontFace = css`
  :root {
    --primary-font-family: ${TitilliumFont}, sans-serif;
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: normal;
    font-weight: 900;
    src: url('${TitilliumWebBlack}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: normal;
    font-weight: 700;
    src: url('${TitilliumWebBold}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: italic;
    font-weight: 700;
    src: url('${TitilliumWebBoldItalic}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: normal;
    font-weight: 600;
    src: url('${TitilliumWebSemiBold}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: italic;
    font-weight: 700;
    src: url('${TitilliumWebSemiBoldItalic}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: normal;
    font-weight: 400;
    src: url('${TitilliumWebRegular}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: italic;
    font-weight: 400;
    src: url('${TitilliumWebItalic}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: normal;
    font-weight: 300;
    src: url('${TitilliumWebLight}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: italic;
    font-weight: 300;
    src: url('${TitilliumWebLightItalic}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: normal;
    font-weight: 200;
    src: url('${TitilliumWebExtraLight}') format('truetype');
  }

  @font-face {
    font-family: '${TitilliumFont}';
    font-style: italic;
    font-weight: 200;
    src: url('${TitilliumWebExtraLightItalic}') format('truetype');
  }
`;
